import { ClientMetrics } from '@vinted/client-metrics'

const ITEM_PAGE_BUY_BUTTON_METRIC_NAME = 'frontend.item.buy_button'

export const incrementItemPageBuyButtonShowCounter = (available: boolean) => {
  ClientMetrics.counter({
    name: ITEM_PAGE_BUY_BUTTON_METRIC_NAME,
    value: 1,
    labels: {
      available,
    },
  })
}
